<template>
	<el-form ref="videoForm" :model="videoForm" label-width="120px">
		<el-row>
			<el-col :span="8">
				<el-form-item label="视频内容">
					<video :src="`${config.RESOURCES + videoForm.videoUrl}`" controls height="300px"></video>
					<!-- <el-upload
            ref="upload"
            :http-request="getOSSUploadInfo"
            action=""
            accept=".mp4,.avi"
            :limit="1"
            :on-exceed="handleExceed"
            :on-remove="onRemove"
            :file-list="uploadFileList"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传mp4/avi文件.</div>
          </el-upload> -->
				</el-form-item>
			</el-col>
		</el-row>

		<el-row>
			<el-col :span="8">
				<el-form-item label="创建者">
					<el-input v-model="videoForm.nickname" disabled />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="创建者ID">
					<el-input v-model="videoForm.createUserID" disabled />
				</el-form-item>
			</el-col>
		</el-row>

		<el-row>
			<el-col :span="8">
				<el-form-item label="收费规则">
					<el-select v-model="videoForm.payStatus" style="width: 100%">
						<el-option label="免费" :value="0" />
						<el-option label="收费" :value="1" />
					</el-select>
				</el-form-item>
			</el-col>
			<el-col v-show="isNeedToPay" :span="8">
				<el-form-item label="费用">
					<el-input v-model="videoForm.price" />
				</el-form-item>
			</el-col>
		</el-row>

		<el-row>
			<el-col :span="8">
				<el-form-item label="试看时长(s)">
					<el-input v-model="videoForm.tryTimeLength" type="number" />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="是否在视频病例界面隐藏">
					<el-radio-group v-model="videoForm.isHideOnMain">
						<el-radio :label="true">是</el-radio>
						<el-radio :label="false">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-col>
		</el-row>

		<el-row>
			<el-col :span="8">
				<el-form-item label="观看次数">
					<el-input v-model="videoForm.watchCount" disabled />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="评论数量">
					<el-input v-model="videoForm.commentCount" disabled />
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="点赞数量">
					<el-input v-model="videoForm.likeCount" disabled />
				</el-form-item>
			</el-col>
		</el-row>

		<el-row>
			<el-col :span="8">
				<el-form-item label="视频类型">
					<el-select v-model="videoForm.categoryID">
						<el-option v-for="item in categoryOptions" :key="item.forumCategoryId"
							:value="item.forumCategoryId" :label="item.categoryName"></el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item v-if="userDataTypeOptions.length > 0" label="所属领域">
					<el-select v-model="videoForm.userDataType" style="width: 100%">
            <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value" :label="item.name"></el-option>
          </el-select>
				</el-form-item>
			</el-col>
		</el-row>

		<el-row>
			<el-col :span="8">
				<el-form-item label="分享方式">
					<el-select v-model="videoForm.shareMode" style="width: 100%">
						<el-option label="个人" :value="0" />
						<el-option label="尊享" :value="1" />
						<el-option label="公开" :value="2" />
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item label="视频标签(可多选)">
					<el-select v-model="videoForm.videoTabList" style="width: 100%" filterable multiple
						@change="videoTabOptionsChange">
						<el-option v-for="item in videoTabOptions" :key="item.videoTabID" :label="item.videoTabTitle"
							:value="item.videoTabID"></el-option>
					</el-select>
				</el-form-item>
			</el-col>
		</el-row>

		<el-form-item label="标题">
			<el-input v-model="videoForm.videoName" />
		</el-form-item>

		<el-form-item label="描述">
			<el-input v-model="videoForm.videoDesc" type="textarea" rows="5" />
		</el-form-item>

		<el-form-item>
			<el-button type="primary" size="small" @click="updateVideo()">
				保存
			</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
	import {
		getOSSUploadInfo
	} from "@/api/aliyun";
	import {
		getOne,
		updateVideo
	} from "@/api/videoDetail";
	import {
		getVideoTabList,
		getCategoryList
	} from "@/api/videoCourse";
	import config from "@/utils/config";
	import {
		isVaild
	} from "@/utils/validate"
	import {
		printObj
	} from "@/utils/debug"
	import {
		handleRes
	} from "@/utils/handleRes"
  import {getUserType} from "@/utils/userutil";
	export default {
		name: "videoDetail",

		props: {
			videoID: {
				type: Number,
			},
		},
		data() {
			return {
        userDataTypeOptions:[],
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				videoForm: {}, // 视频详情表单
				// 视频标签选项列表
				videoTabOptions: [],
				// ossInfo: {}, // OSS 信息
				// ossPath: "", // oss 路径
				// uploadFileList: [], // 上传文件列表
				categoryOptions: [],
			};
		},

		computed: {
			// 内部员工无需选择系列
			isNeedToPay: function() {
				if (this.videoForm.payStatus === 1) {
					return true;
				} else {
					return false;
				}
			},
		},

		async activated() {
      this.userDataTypeOptions = getUserType()
			this.getOne();
			this.getCategoryList()

			const res = await this.getAllVideoTabList();
			this.videoTabOptions = res
			this.$forceUpdate()
		},

		deactivated() {},

		methods: {
			/**
			 * 获取OSS上传信息
			 *
			 * @param {object} file 文件对象
			 */
			// async getOSSUploadInfo(file) {
			//   console.log(file);
			//   const params = {
			//     DataType: 14, // 14 视频课程评论图片或者视频
			//     ID: this.videoID,
			//   };

			//   const res = await getOSSUploadInfo(params);
			//   const { PicSavePath, AssumeRoleToken } = res.resultData;
			//   this.ossInfo = AssumeRoleToken;
			//   this.ossPath = PicSavePath;
			//   this.uploadFile(file);
			// },
			// uploadFile(file) {
			//   const uploadFile = file.file; // 获取上传文件
			//   const uploadFileSize = uploadFile.size / 1024 / 1024; // 获取上传文件的大小，单位 MB

			//   if (uploadFileSize >= 10) {
			//     // 分片上传
			//     console.log("分片上传");
			//     this.multipartUpload(file);
			//   } else {
			//     // 简单上传
			//     console.log("简单上传");
			//     this.commonUpload(file);
			//   }
			// },
			// /**
			//  * 分片上传
			//  */
			// async multipartUpload(file) {
			//   let OSS = require("ali-oss");
			//   // 实例化OSS Client。
			//   let client = new OSS({
			//     region: this.config.OSS_END_POINT,
			//     accessKeyId: this.ossInfo.AccessKeyId,
			//     accessKeySecret: this.ossInfo.AccessKeySecret,
			//     stsToken: this.ossInfo.SecurityToken,
			//     bucket: config.OSSBUCKET,
			//     timeout: 600000,
			//   });

			//   // optional args
			//   const options = {
			//     // 获取分片上传进度、断点和返回值。
			//     progress: (p, cpt, res) => {
			//       console.log(p, cpt, res);
			//     },
			//     // 设置并发上传的分片数量。
			//     parallel: 4,
			//     // 设置分片大小。默认值为1 MB，最小值为100 KB。
			//     partSize: 1024 * 1024,
			//   };

			//   let timestamp = new Date().valueOf();
			//   const fileName = file.file.uid + "_" + timestamp;

			//   try {
			//     const result = await client.multipartUpload(
			//       this.ossPath + fileName,
			//       file.file,
			//       options
			//     );
			//     console.log("上传文件result：", result);

			//     // 上传成功
			//     if (result.url && result.res.status === 200) {
			//       this.videoForm.videoUrl = "/" + this.ossPath + fileName;
			//       console.log("this", this.videoForm.videoUrl);
			//       this.updateVideo();
			//     }
			//     // 上传失败
			//     else {
			//       this.$message({
			//         type: "error",
			//         message: "上传失败",
			//       });
			//     }
			//   } catch (e) {
			//     this.$message({
			//       type: "error",
			//       message: "上传失败",
			//     });
			//   }
			// },
			// /**
			//  * 简单上传
			//  */
			// async commonUpload(file) {
			//   let OSS = require("ali-oss");
			//   // 实例化OSS Client。
			//   let client = new OSS({
			//     region: this.config.OSS_END_POINT,
			//     accessKeyId: this.ossInfo.AccessKeyId,
			//     accessKeySecret: this.ossInfo.AccessKeySecret,
			//     stsToken: this.ossInfo.SecurityToken,
			//     bucket: config.OSSBUCKET,
			//     timeout: 600000,
			//   });

			//   let timestamp = new Date().valueOf();
			//   const fileName = file.file.uid + "_" + timestamp;

			//   try {
			//     const result = await client.put(this.ossPath + fileName, file.file);
			//     console.log("上传文件result：", result);

			//     // 上传成功
			//     if (result.url && result.res.status === 200) {
			//       this.videoForm.videoUrl = "/" + this.ossPath + fileName;
			//       console.log("this", this.videoForm.videoUrl);
			//       this.updateVideo();
			//     }
			//     // 上传失败
			//     else {
			//       this.$message({
			//         type: "error",
			//         message: "上传失败",
			//       });
			//     }
			//   } catch (e) {
			//     this.$message({
			//       type: "error",
			//       message: "上传失败",
			//     });
			//   }
			// },
			videoTabOptionsChange() {
				this.$forceUpdate()
			},
			/**
			 * 获取部位列表
			 */
			async getCategoryList() {
				let getCategoryRes = await getCategoryList()
				handleRes(getCategoryRes, () => {
					// printObj(getCategoryRes)
					this.categoryOptions = getCategoryRes.data
				})
			},
			/**
			 * 获取单个视频详情
			 */
			getOne() {
				const params = {
					videoID: Number(this.videoID),
				};
				getOne(params).then((res) => {
					this.videoForm = res.data;
					if (!isVaild(this.videoForm.isHideOnMain)) {
						this.videoForm.isHideOnMain = false
					}
					if (isVaild(this.videoForm.videoTabList)) {
						this.videoForm.videoTabList = this.videoForm.videoTabList.map((item) => {
							return item.videoTabID;
						});
					}
				});
			},
			/**
			 * 更新单个视频详情
			 */
			updateVideo() {
				// 格式化数据
				if (this.videoForm.videoTabList.length > 0) {
					this.videoForm.videoTabIDs = this.videoForm.videoTabList.join();
				}
				// printObj(this.videoForm);

				updateVideo(this.videoForm).then((res) => {
					if (res.code === 200) {
						this.$message({
							type: "success",
							message: "保存成功",
						});
						this.getOne();
					} else {
						this.$message({
							type: "warning",
							message: res.message,
						});
					}
				});
			},
			/**
			 * 上传数量限制提示
			 */
			handleExceed() {
				this.$message({
					message: "只能上传一个视频",
					type: "warning",
				});
			},
			/**
			 * 监听移除文件，更新数组
			 *
			 * @param {object} file 文件对象
			 * @param {array} fileList 文件对象列表
			 */
			onRemove(file, fileList) {
				this.uploadFileList = fileList;
			},
			/**
			 * 上传限制校验
			 *
			 * @param {object} file 文件对象
			 */
			beforeUpload(file) {
				// 文件类型限制
				let exname = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
				const fileTypes = ["mp4", "avi"];
				if (fileTypes.indexOf(exname) < 0) {
					this.$message({
						message: "上传视频只能是 mp4/avi 格式!",
						type: "warning",
					});
					return false;
				}
			},
			/**
			 * 获取所有视频标签选项
			 */
			getAllVideoTabList() {
				this.loading = true;
				const params = {
					// sortName: "",
					// sortOrder: "",
					pageNumber: 1,
					pageSize: 10,
				};
				// 秀一下链式调用
				// 第一次调用拿到 totalCount，然后通过 totalCount 拿到全部视频标签
				const data = getVideoTabList(params)
					.then((res) => {
						return res.data.total;
					})
					.then((res) => {
						return getVideoTabList({
							pageNumber: 1,
							pageSize: res
						});
					})
					.then((res) => {
						this.utils.stopLoading(this);
						return res.data.rows;
					});
				return data;
			},
		},
	};
</script>


<style scoped lang="scss">
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	::v-deep .el-input {
		width: 80%;
	}
</style>
